import { Link, type LinkProps } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'
import { cn } from '#app/utils/misc.tsx'

/**
 * The shared brand "read more" link used across the marketing teasers — the
 * home capabilities teaser ({@link ./__feature-teaser.tsx}) and the home FAQ
 * teaser ({@link ./__faq-teaser.tsx}). A brand-tinted label followed by an
 * `arrow-right` glyph that nudges right on hover, all within one focus ring.
 * One source so the affordance stays identical wherever a teaser hands off to
 * its full page; callers pass extra layout classes (spacing, alignment) via
 * `className`.
 */
export function BrandLink({ className, children, ...props }: LinkProps) {
	return (
		<Link
			{...props}
			className={cn(
				'text-brand group/link focus-cosy text-body-sm inline-flex items-center gap-1.5 rounded font-medium',
				className,
			)}
		>
			{children}
			<Icon
				name="arrow-right"
				aria-hidden
				className="transition-transform group-hover/link:translate-x-0.5"
			/>
		</Link>
	)
}
